"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var classnames_1 = __importDefault(require("classnames"));

require("./SzNotification.scss");

var SzIcon_1 = __importDefault(require("../SzIcon/SzIcon"));

function SzNotification(_a) {
  var notifCount = _a.notifCount,
      className = _a.className;
  var notificationClasses = classnames_1.default('d-md-flex align-items-center justify-content-center position-relative', className);
  return react_1.default.createElement("div", {
    className: notificationClasses
  }, react_1.default.createElement(SzIcon_1.default, {
    icon: "alarm-bell",
    variant: "bold",
    classNameclassName: "sz-icon-notifications normal"
  }), notifCount && react_1.default.createElement("span", {
    className: "sz-notification-number sz-small-font-size text-center position-absolute text-white bg-danger rounded-circle"
  }, notifCount));
}

exports.default = SzNotification;
SzNotification.propTypes = {
  notifCount: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]).isRequired,
  className: prop_types_1.default.string
};